export const MODAL_ID = 'lead-confirm-details';

export const COPY =
  'Are you sure all of the quote details are correct? If you would like to add a deposit or any unregulated finance rates, click edit instead';
